import React from "react";
import PropTypes from "prop-types";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
// MDB Shim Imports
import Button from "../../Component/MDBShim/Button";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Container from "../../Component/MDBShim/Container";
import Col from "../../Component/MDBShim/Col";
import Input from "../../Component/MDBShim/Input";
import MDBInput from "../../Component/MDBShim/MDBInput";
import Row from "../../Component/MDBShim/Row";
import Spinner from "../../Component/MDBShim/Spinner";
import MDBIcon from "../../Component/MDBShim/MDBIcon";

import "./userEdit.css";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUIChip from "@mui/material/Chip";
import MUITextField from "@mui/material/TextField";
import UserService from "../Security/UserService/userService";
import api from "../Security/api";
import globalFunctions from "../Filters/GlobalFunctions";
import LayerLegacy from "../../LayerLegacy";
import Permission from "../../Utility/Crud/Permission";
import Role from "../../Utility/Crud/Role";
import MainContext from "../../Context/MainContext/MainContext";
import ROLE_SETTINGS_BY_NEW_ROLE_ID from "./RoleSettingsByNewRoleId";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import Format from "../../Utility/Format";
import Validator from "../../Utility/Validator";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});

export default class userEdit extends LayerLegacy {
  constructor(props) {
    super(props);

    let user = {},
      isLoaded = false,
      id = props.match.params.id;

    this.retrieveUser(id);

    if (!user.userprofileLocations || user.userprofileLocations === null) {
      user.userprofileLocations = [];
    }

    this.state = {
      isLoaded: isLoaded,
      user: user,
      eUser: JSON.parse(JSON.stringify(user)),
      npw: "",
      cpw: "",
      allLocations: [],
      selectedRoleIds: [],
      originalUserprofileRoleRows: [],
    };
  }

  static contextType = MainContext; // For legacy class components

  componentDidMount() {
    this.getLocations();
  }

  retrieveUser(id) {
    return UserService.getUser(id).then((data) => {
      // console.log(data)
      if (data.userprofileLocations === null) {
        data.userprofileLocations = [];
      }
      data.username = this.deriveUsername(data.email);
      const userprofileRoleRows = this.getUserprofileRoleRowsForUser(data.id);

      this.setState({
        user: data,
        eUser: JSON.parse(JSON.stringify(data)),
        selectedRoleIds: userprofileRoleRows.map(
          (userprofileRole) => userprofileRole.roleId,
        ),
        originalUserprofileRoleRows: JSON.parse(
          JSON.stringify(userprofileRoleRows),
        ),
        isLoaded: true,
      });
    });
  }

  getLocations() {
    const { allLocations } = this.context;
    let userLocs =
        this.state.eUser.userprofileLocations.map((x) => x.locations) || [],
      locsMini = [];

    if (userLocs) {
      userLocs.forEach((l) => {
        locsMini.push(l.name);
      });
    }

    let a = [];
    a.push({
      label: "Select Location...",
      value: "",
    });

    allLocations.map((loc) => {
      return a.push({
        label: loc.name,
        value: loc,
      });
    });

    if (locsMini && locsMini.length > 0) {
      a = a.filter((x) => locsMini.indexOf(x.label) === -1);
    }

    return a;
  }

  getUserprofileRoleRowsForUser(userId) {
    const { userprofileRolesIndexed } = this.context;
    const userprofileRoles = userprofileRolesIndexed
      ? Object.values(userprofileRolesIndexed)
      : [];
    return userprofileRoles.filter(
      (userprofileRole) => userprofileRole.userProfileId === userId,
    );
  }

  getRoleOptions() {
    const { rolesIndexed } = this.context;
    const roles = rolesIndexed ? Object.values(rolesIndexed) : [];
    return Role.sort(roles);
  }

  getPermissionOptions() {
    const { permissionsIndexed } = this.context;
    const permissions = permissionsIndexed
      ? Object.values(permissionsIndexed)
      : [];
    return Permission.sort(permissions);
  }

  deriveUsername(email) {
    if (!email || !email.includes("@")) {
      return "";
    }
    return email.split("@")[0].trim();
  }

  requiresRehabMedicalEmail(email) {
    const { companyName } = this.context;
    return (
      ["rehabmedical", "uat"].includes(String(companyName).toLowerCase()) &&
      Boolean(email) &&
      !email.trim().toLowerCase().endsWith("@rehabmedical.com")
    );
  }

  getLegacyRoleOptions() {
    return Array.from(
      new Set(
        Object.values(ROLE_SETTINGS_BY_NEW_ROLE_ID).map(
          (settings) => settings.legacyRole,
        ),
      ),
    ).sort();
  }

  getRoleSettingsFromMostRecentRole(previousRoleIds, nextRoles) {
    const previousRoleIdsSet = new Set(
      (previousRoleIds || []).map((roleId) => String(roleId)),
    );
    const addedRoles = (nextRoles || []).filter(
      (role) => !previousRoleIdsSet.has(String(role.id)),
    );
    if (addedRoles.length === 0) {
      return null;
    }
    const mostRecentAddedRole = addedRoles[addedRoles.length - 1];
    return ROLE_SETTINGS_BY_NEW_ROLE_ID[mostRecentAddedRole.id] || null;
  }

  handleRolesChange = (e, roles, reason) => {
    const nextSelectedRoleIds =
      reason === "selectOption"
        ? roles.length > 0
          ? [roles[roles.length - 1].id]
          : []
        : roles.map((role) => role.id);
    const mappedSettings = this.getRoleSettingsFromMostRecentRole(
      this.state.selectedRoleIds,
      roles,
    );

    this.setState((prevState) => ({
      selectedRoleIds: nextSelectedRoleIds,
      eUser: mappedSettings
        ? {
            ...prevState.eUser,
            role: mappedSettings.legacyRole,
            canEditPoints: mappedSettings.canEditPoints,
            isAtp: mappedSettings.isAtp,
          }
        : prevState.eUser,
    }));
  };

  handleLegacyRoleChange = (e, legacyRole) => {
    this.setState((prevState) => ({
      eUser: {
        ...prevState.eUser,
        role: legacyRole || "",
      },
    }));
  };

  saveUserprofileRoleChanges(userId) {
    const originalUserprofileRoleRows =
      this.state.originalUserprofileRoleRows || [];
    const selectedRoleIds = [...new Set(this.state.selectedRoleIds || [])];
    const selectedRoleIdsSet = new Set(
      selectedRoleIds.map((roleId) => String(roleId)),
    );
    const originalRoleIdsSet = new Set(
      originalUserprofileRoleRows.map((userprofileRole) =>
        String(userprofileRole.roleId),
      ),
    );

    const roleIdsToAdd = selectedRoleIds.filter(
      (roleId) => !originalRoleIdsSet.has(String(roleId)),
    );
    const userprofileRolesToRemove = originalUserprofileRoleRows.filter(
      (userprofileRole) =>
        !selectedRoleIdsSet.has(String(userprofileRole.roleId)),
    );

    const addPromises = roleIdsToAdd.map((roleId) =>
      api
        .send("POST", "/userprofileRole", {
          userProfileId: userId,
          roleId: roleId,
        })
        .then((createdUserprofileRole) => {
          this.context.updateIndexed(
            "userprofileRolesIndexed",
            createdUserprofileRole,
          );
          return createdUserprofileRole;
        }),
    );

    const removePromises = userprofileRolesToRemove.map((userprofileRole) =>
      api.send("DELETE", `/userprofileRole/${userprofileRole.id}`).then(() => {
        this.context.deleteIndexed(
          "userprofileRolesIndexed",
          userprofileRole.id,
        );
      }),
    );

    return Promise.all([...addPromises, ...removePromises]).then((results) => {
      const createdUserprofileRoles = results.slice(0, addPromises.length);
      const retainedUserprofileRoles = originalUserprofileRoleRows.filter(
        (userprofileRole) =>
          selectedRoleIdsSet.has(String(userprofileRole.roleId)),
      );

      return retainedUserprofileRoles.concat(createdUserprofileRoles);
    });
  }

  addUserLocation(location) {
    let l = location.value,
      eUser = this.state.eUser;
    console.log(l, eUser);
    //Search to make sure this location doesn't already exist...BC
    let idx = eUser.userprofileLocations.findIndex((loc) => {
      return loc.locationsId === l.id;
    });

    //Only add if it doesn't exist...BC
    if (idx === -1) {
      let locationRef = {
        id: l.id,
        name: l.name,
      };

      eUser.userprofileLocations.push({
        userprofileId: eUser.id,
        locationsId: l.id,
        locations: locationRef,
      });
    }

    this.setState({ eUser: eUser });
  }

  addAllLocations() {
    const { allLocations } = this.context;

    let eUser = this.state.eUser;

    allLocations.forEach((loc) => {
      let idx = eUser.userprofileLocations.findIndex((ul) => {
        return ul.locationsId === loc.id;
      });

      if (idx === -1) {
        let locationRef = {
          id: loc.id,
          name: loc.name,
        };

        eUser.userprofileLocations.push({
          userprofileId: eUser.id,
          locationsId: locationRef.id,
          locations: locationRef,
        });
      }
    });

    this.setState({ eUser: eUser });
  }

  removeUserLocation(location) {
    let eUser = this.state.eUser;

    let idx = eUser.userprofileLocations.findIndex((loc) => {
      return loc.locationsId === location.id;
    });

    if (idx !== -1) {
      eUser.userprofileLocations.splice(idx, 1);
    }

    this.setState({ eUser: eUser });
  }

  updateUser() {
    let u = this.state.eUser;
    u.email = u.email.trim();
    u.username = this.deriveUsername(u.email);

    if (
      !this.state.user.active &&
      !u.active &&
      !u.email.includes("-deleted-")
    ) {
      u.email = u.email + "-deleted-" + globalFunctions.getUTCMoment();
      u.userprofileLocations = [];
    }

    return UserService.updateUser(u)
      .then(() => this.saveUserprofileRoleChanges(u.id))
      .then((nextUserprofileRoleRows) => {
        NotistackEnqueueSnackbar("Saved Successfully!", { variant: "success" });
        this.setState({
          user: u,
          eUser: JSON.parse(JSON.stringify(u)),
          originalUserprofileRoleRows: JSON.parse(
            JSON.stringify(nextUserprofileRoleRows),
          ),
          selectedRoleIds: nextUserprofileRoleRows.map(
            (userprofileRole) => userprofileRole.roleId,
          ),
        });
      })
      .catch((err) => {
        NotistackEnqueueSnackbar("An error occurred while saving.", {
          variant: "warning",
        });
      });
  }

  handleChange = (property, event) => {
    const nUser = this.state.eUser;
    //update the property that the user has edited in the order...BC
    if (property === "brightreeExternalId") {
      let value = parseInt(event.target.value);
      nUser[property] = value;
    } else if (property === "email") {
      nUser.email = event.target.value;
      nUser.username = this.deriveUsername(event.target.value);
      this.setState({ eUser: nUser });
      return;
    } else {
      nUser[property] = event.target.value;
    }

    this.setState({ eUser: nUser });
  };

  handlePhoneOrFaxNumberChange = (property, event) => {
    const { value } = event.target;
    const digits = value.replace(/\D/g, "").slice(0, 10);
    this.setState({
      eUser: { ...this.state.eUser, [property]: digits ? digits : null },
    });
  };

  handleBlur = (property, event) => {
    const eUser = this.state.eUser;
    const value = event?.target?.value;
    if (typeof value !== "string") {
      return;
    }

    eUser[property] = value.trim();
    if (property === "email") {
      eUser.username = this.deriveUsername(eUser[property]);
    }

    this.setState({ eUser: eUser });
  };

  validateForm() {
    let e = this.state.eUser;
    if (e.username === "") {
      return "Please enter a username.";
    } else if (e.firstname === "") {
      return "Please enter a first name.";
    } else if (e.lastname === "") {
      return "Please enter a last name.";
    } else if (e.role === "") {
      return "Please select a legacy role.";
    } else if ((this.state.selectedRoleIds || []).length === 0) {
      return "Please select at least one new role.";
    } else if (!e.email || e.email === "") {
      return "Please enter an email.";
    } else if (!(e.email.includes("@") && e.email.includes("."))) {
      return "Please enter a valid email address.";
    } else if (e.active && this.requiresRehabMedicalEmail(e.email)) {
      return "email must be @rehabmedical";
    } else if (e.phone && !Validator.validatePhone(e.phone)) {
      return "Please enter a valid 10-digit phone number.";
    } else if (e.fax && !Validator.validatePhone(e.fax)) {
      return "Please enter a valid 10-digit fax number.";
    }
    return true;
  }

  renderErrorMessage() {
    let res = this.validateForm();

    let save = (
      <Button
        floating
        size="sm"
        color={"success"}
        data-tip={"Update User"}
        onClick={this.updateUser.bind(this)}
      >
        <MDBIcon far icon="save" style={{ fontSize: "2em" }} />
      </Button>
    );

    let error = (
      <Button floating size="sm" color={"red"} data-tip={res}>
        <MDBIcon icon="times" style={{ fontSize: "2em" }} />
      </Button>
    );

    if (res !== true) {
      return error;
    }

    //return the chip...BC
    return save;
  }

  renderLoadingSpinner() {
    return (
      <Container className="mt-5">
        <div style={{ textAlign: "center", verticalAlign: "center" }}>
          <Spinner multicolor />
        </div>
      </Container>
    );
  }

  renderLocationsCard() {
    let locsSort =
      this.state.eUser.userprofileLocations.map((x) => x.locations) || [];
    if (locsSort && locsSort.length > 1) {
      locsSort.sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    return (
      <div>
        <Card>
          <CardHeader
            style={{
              textAlign: "center",
              backgroundColor: "#5881C1",
              color: "#FFF",
              fontSize: 30,
              minHeight: 82,
            }}
          >
            <h2>Locations</h2>
          </CardHeader>
          <CardBody>
            <Row>
              <Col size="9">
                <Select
                  placeholder={"Select Location..."}
                  options={this.getLocations()}
                  onChange={this.addUserLocation.bind(this)}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </Col>

              <Col size="3">
                <Button
                  floating
                  size="sm"
                  color={"green"}
                  data-tip={"Add All Locations"}
                  onClick={() => this.addAllLocations()}
                  style={{ marginLeft: "20px" }}
                >
                  <MDBIcon icon="plus" style={{ fontSize: "2em" }} />
                </Button>
              </Col>
            </Row>

            <br />

            <div
              style={{
                overflowX: "hidden",
                overFlowY: "auto",
                maxHeight: "400px",
              }}
            >
              {locsSort
                ? locsSort.map((loc, idx) => {
                    return (
                      <Row key={idx}>
                        <Col size="9">
                          <h5>{loc.name}</h5>
                        </Col>
                        <Col size="3">
                          <Button
                            floating
                            size="sm"
                            color={"red"}
                            data-tip={"Remove Location"}
                            onClick={this.removeUserLocation.bind(this, loc)}
                          >
                            <MDBIcon icon="times" style={{ fontSize: "2em" }} />
                          </Button>
                        </Col>
                        <ReactTooltip />
                      </Row>
                    );
                  })
                : ""}
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }

  renderUserCard() {
    let user = this.state.eUser;
    const roleOptions = this.getRoleOptions();
    const permissionOptions = this.getPermissionOptions();
    const selectedRoleIdsSet = new Set(
      (this.state.selectedRoleIds || []).map((roleId) => String(roleId)),
    );
    const selectedRoles = roleOptions.filter((role) =>
      selectedRoleIdsSet.has(String(role.id)),
    );
    // --- Begin: Other Permissions Section ---
    const context = this.context;
    const userprofilePermissions = context.userprofilePermissionsIndexed
      ? Object.values(context.userprofilePermissionsIndexed)
      : [];
    const userprofileRoles = context.userprofileRolesIndexed
      ? Object.values(context.userprofileRolesIndexed)
      : [];
    const rolePermissions = context.rolePermissionsIndexed
      ? Object.values(context.rolePermissionsIndexed)
      : [];

    const directUserPermissions = userprofilePermissions.filter(
      (userprofilePermission) =>
        userprofilePermission.userProfileId === user.id &&
        userprofilePermission.deleted !== true,
    );

    const deniedPermissionIds = directUserPermissions
      .filter((userprofilePermission) => userprofilePermission.deny === true)
      .map((userprofilePermission) => userprofilePermission.permissionId);

    const grantedPermissionIds = directUserPermissions
      .filter((userprofilePermission) => userprofilePermission.deny !== true)
      .map((userprofilePermission) => userprofilePermission.permissionId);

    const userRoleIds = userprofileRoles
      .filter(
        (userprofileRole) =>
          userprofileRole.userProfileId === user.id &&
          userprofileRole.deleted !== true,
      )
      .map((userprofileRole) => userprofileRole.roleId);

    const rolePermissionIds = rolePermissions
      .filter(
        (rolePermission) =>
          userRoleIds.includes(rolePermission.roleId) &&
          rolePermission.deleted !== true,
      )
      .map((rolePermission) => rolePermission.permissionId);

    const allGrantedPermissionIds = Array.from(
      new Set([...grantedPermissionIds, ...rolePermissionIds]),
    ).filter((permissionId) => !deniedPermissionIds.includes(permissionId));

    const allGrantedPermissionIdsSet = new Set(
      allGrantedPermissionIds.map((permissionId) => String(permissionId)),
    );
    const selectedPermissions = permissionOptions.filter((permission) =>
      allGrantedPermissionIdsSet.has(String(permission.id)),
    );
    // --- End: Other Permissions Section ---

    return (
      <Card>
        <CardHeader
          style={{
            textAlign: "center",
            backgroundColor: "#5881C1",
            color: "#FFF",
            fontSize: 30,
            minHeight: 82,
          }}
        >
          <Row>
            <Col size="8" className="align-self-center">
              <h2>
                {this.state.user.firstname + " " + this.state.user.lastname}
              </h2>
            </Col>

            <Col size="4" style={{ padding: 0 }} className="align-self-center">
              {this.renderErrorMessage()}
            </Col>
            <ReactTooltip />
          </Row>
        </CardHeader>

        <CardBody>
          <Row>
            <Col size="12" style={{ marginBottom: "15px" }}>
              <Input
                fullWidth={true}
                outline
                value={user.email || ""}
                onChange={this.handleChange.bind(this, "email")}
                onBlur={this.handleBlur.bind(this, "email")}
                label="Email"
                size="small"
              />
              {user.active && this.requiresRehabMedicalEmail(user.email) && (
                <div
                  style={{
                    color: "#c62828",
                    fontSize: "0.875rem",
                    marginTop: "4px",
                  }}
                >
                  email must be @rehabmedical
                </div>
              )}
            </Col>
          </Row>

          <Row gap={1} style={{ marginBottom: "15px" }}>
            <Col size="5.9">
              <Input
                fullWidth={true}
                outline
                value={user.firstname || ""}
                onChange={this.handleChange.bind(this, "firstname")}
                onBlur={this.handleBlur.bind(this, "firstname")}
                label="First Name"
                size="small"
              />
            </Col>
            <Col size="5.9">
              <Input
                fullWidth={true}
                outline
                value={user.lastname || ""}
                onChange={this.handleChange.bind(this, "lastname")}
                onBlur={this.handleBlur.bind(this, "lastname")}
                label="Last Name"
                size="small"
              />
            </Col>
          </Row>

          <Row gap={1} style={{ marginBottom: "15px" }}>
            <Col size="5.9">
              <Input
                fullWidth={true}
                outline
                value={Format.phone(user.fax)}
                onChange={this.handlePhoneOrFaxNumberChange.bind(this, "fax")}
                size="small"
                label="Fax"
              />
            </Col>

            <Col size="5.9">
              <Input
                fullWidth={true}
                outline
                value={Format.phone(user.phone)}
                onChange={this.handlePhoneOrFaxNumberChange.bind(this, "phone")}
                size="small"
                label="Phone"
              />
            </Col>
          </Row>

          <Row style={{ marginBottom: "15px" }}>
            <Col size="12">
              <Input
                fullWidth={true}
                outline
                value={user.username || ""}
                label="Username"
                size="small"
                disabled
                style={{ opacity: 0.55, cursor: "not-allowed" }}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: "15px" }}>
            <Col size="12">
              <Input
                fullWidth={true}
                outline
                value={user.brightreeExternalId || ""}
                onChange={this.handleChange.bind(this, "brightreeExternalId")}
                onBlur={this.handleBlur.bind(this, "brightreeExternalId")}
                label="Brightree ID"
                size="small"
              />
            </Col>
          </Row>
          <Row>
            <Col size="12">
              <div style={{ marginTop: 16 }}>
                <hr style={{ marginBottom: 16 }} />
                <h5 style={{ marginBottom: 16 }}>Roles & Permissions</h5>
              </div>
            </Col>
          </Row>
          <Row>
            <Col size="12">
              <div style={{ marginTop: 4 }}>
                <MUIAutocomplete
                  multiple
                  options={roleOptions}
                  value={selectedRoles}
                  getOptionLabel={(role) => Role.getDisplayName(role)}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={this.handleRolesChange}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <MUIChip
                        size="small"
                        label={Role.getDisplayName(option)}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <MUITextField
                      {...params}
                      size="small"
                      label="Roles"
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginBottom: "15px" }}>
            <Col size="12">
              <div style={{ marginTop: 12 }}>
                <MUIAutocomplete
                  options={this.getLegacyRoleOptions()}
                  value={user.role || ""}
                  onChange={this.handleLegacyRoleChange}
                  renderInput={(params) => (
                    <MUITextField
                      {...params}
                      size="small"
                      label="Legacy Role"
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginBottom: "15px" }}>
            <Col size="12">
              <div style={{ marginTop: 12 }}>
                <MUIAutocomplete
                  multiple
                  disabled
                  options={permissionOptions}
                  value={selectedPermissions}
                  getOptionLabel={(permission) =>
                    Permission.getDisplayName(permission)
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <MUIChip
                        size="small"
                        label={Permission.getDisplayName(option)}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <MUITextField
                      {...params}
                      size="small"
                      label="Permissions"
                      variant="standard"
                      helperText={
                        deniedPermissionIds.length > 0
                          ? `${deniedPermissionIds.length} denied permission(s) excluded`
                          : ""
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col size="6">
              <MDBInput
                id="pointsStatus"
                label="Can Edit Points"
                checked={user.canEditPoints}
                value={user.canEditPoints}
                onChange={this.handlePoints}
                type="checkbox"
              />
            </Col>
            <Col size="6">
              <MDBInput
                id="atpStatus"
                label="is ATP"
                checked={user.isAtp}
                value={user.isAtp}
                onChange={this.handleAtp}
                type="checkbox"
              />
            </Col>
          </Row>
          <Row>
            <Col size="12">
              <MDBInput
                id="activeStatus"
                label="Active"
                checked={user.active}
                value={user.active}
                onChange={this.handleActive}
                type="checkbox"
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  handleActive = () => {
    let u = this.state.eUser;
    u.active = !u.active;

    if (this.state.user.active && !u.active && !u.email.includes("-deleted-")) {
      u.email = u.email + "-deleted-" + globalFunctions.getUTCMoment();
      u.userprofileLocations = [];
    } else if (
      this.state.user.active &&
      u.active &&
      u.email.includes("-deleted-")
    ) {
      let index = u.email.indexOf("-deleted-");
      u.email = u.email.slice(0, index);
      u.userprofileLocations = this.state.user.userprofileLocations;
    } else if (
      !this.state.user.active &&
      !u.active &&
      !u.email.includes("-deleted-")
    ) {
      u.email = u.email + "-deleted-" + globalFunctions.getUTCMoment();
      u.userprofileLocations = [];
    } else if (
      !this.state.user.active &&
      u.active &&
      u.email.includes("-deleted-")
    ) {
      let index = u.email.indexOf("-deleted-");
      u.email = u.email.slice(0, index);
      //u.userprofileLocations = this.state.user.userprofileLocations // Display "Inactive Users" (if applicable) so we don't confuse our users
    }

    this.setState({
      eUser: u,
    });
  };

  handlePoints = () => {
    let u = this.state.eUser;
    u.canEditPoints = !u.canEditPoints;
    this.setState({
      eUser: u,
    });
  };

  handleAtp = () => {
    let u = this.state.eUser;
    u.isAtp = !u.isAtp;
    this.setState({
      eUser: u,
    });
  };

  renderContent() {
    if (this.state.isLoaded === false) {
      return (
        <ThemeProvider theme={fixedLightMaterialUITheme}>
          {this.renderLoadingSpinner()}
        </ThemeProvider>
      );
    }

    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <div style={{ color: "rgba(0, 0, 0, 0.87)" }}>
          <Container
            className="mt-4"
            style={{ maxWidth: "1200px", width: "100%" }}
          >
            <Row>
              <Col size={"7"} style={{ padding: 5 }}>
                {this.renderUserCard()}
              </Col>
              <Col size={"5"} style={{ padding: 5 }}>
                {this.renderLocationsCard()}
              </Col>
            </Row>
          </Container>
        </div>
      </ThemeProvider>
    );
  }
}
